export const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4000";

export function apiFetch(path, options) {
  return fetch(`${API_URL}${path.startsWith("/") ? path : "/" + path}` , options);
}